import "./AccountFlyoutBackButton.scss";

import * as React from "react";
import { FormattedMessage } from "react-intl";

type Props = {
    setPageNumber: (pageNumber: number) => void;
};

export function AccountFlyoutBackButton(props: Props) {
    return (
        <div className="back-section" onClick={() => props.setPageNumber(1)}>
            <div className="back-svg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 32 32"
                    version="1.1">
                    <defs>
                        <path
                            d="M27,15.00125 L7.414,15.00125 L14.709,7.70725 C15.1,7.31625 15.1,6.68325 14.709,6.29325 C14.318,5.90225 13.686,5.90225 13.295,6.29325 L4.294,15.29325 C4.202,15.38525 4.129,15.49525 4.078,15.61625 C4.027,15.73725 4,15.86825 4,16.00125 C4,16.13425 4.027,16.26525 4.078,16.38625 C4.129,16.50725 4.202,16.61725 4.294,16.70925 L13.295,25.70925 C13.49,25.90525 13.746,26.00225 14.002,26.00225 C14.258,26.00225 14.514,25.90525 14.709,25.70925 C15.1,25.31925 15.1,24.68625 14.709,24.29525 L7.414,17.00125 L27,17.00125 C27.553,17.00125 28,16.55325 28,16.00125 C28,15.44925 27.553,15.00125 27,15.00125"
                            id="path-4"
                        />
                    </defs>
                    <g id="Icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Icon-/-medium-/-arrow-left">
                            <polygon id="fill" points="0 0 32 0 32 32 0 32" />
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-4" />
                            </mask>
                            <use id="color" fill="#0064fe" xlinkHref="#path-4" />
                        </g>
                    </g>
                </svg>
            </div>
            <div className="back-label">
                <FormattedMessage id={"CIA_FLYOUT_BACK_BUTTON"} />
            </div>
        </div>
    );
}
